import { useQuery } from '@tanstack/react-query';

import * as dp from '../data-provider/quote-validation-schema';

export const useValidationSchemas = () => {
  return useQuery(dp.validationSchemasQueryOptions());
};
